import { API_URLS } from "../constants";
import { postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

//Getting Paginated Activity Logs
const getActivityLogs = (body) => {
  return postRequest(API_URLS.ACTIVITY.ACTIVITY_LOG, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Exporting functions for other files
export const activityLogsService = {
  getActivityLogs,
};
